import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemGroupDeleteAtom = createMutationAtomFactory(
  'settings.itemGroupDelete',
  (params: { id: string }) => ({
    inventoryItemGroupDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
